<nav
  class="navbar navbar-expand-lg navbar-light bg-white border-bottom border-top"
>
  <div class="container-fluid justify-content-between">
    <button
      class="navbar-toggler"
      type="button"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      (click)="toggleMenu()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse justify-content-center offcanvas-menu"
      id="navbarNav"
    >
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" style="cursor: pointer;"
             [routerLink]="['/']"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            {{ "translations.home" | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link"
             [routerLink]="['/about']"
             routerLinkActive="active">
            {{ "translations.about" | translate }}
          </a>
        </li>

        <!--<li *ngFor="let category of dataSourceCategory | slice : 0 : 5">
    <a class="nav-link"
       [routerLink]="['/products', category.inCategoryID]"
       routerLinkActive="active">
      {{ currentLang === "ar" ? category.nameAr : category.name }}
    </a>
  </li>-->

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ "translations.Wathces" | translate }}
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:6}]"> {{ "translations.Men" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:7}]"> {{ "translations.Women" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:8}]"> {{ "translations.Couple" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:16}]"> {{ "translations.Digital" | translate }}</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ "translations.Wallets" | translate }}
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:9}]"> {{ "translations.Men" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products', { CID: 10}]"> {{ "translations.Women" | translate }}</a></li>
          </ul>
        </li>

        <li class="nav-item">
          <a class="nav-link"
             [routerLink]="['/products', { CID:11}]"
             routerLinkActive="active">
            {{ "translations.Pens" | translate }}
          </a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ "translations.BAGS" | translate }}
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:18}]"> {{ "translations.Men_Hand_Bags" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:12}]"> {{ "translations.Women_Hand_Bags" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:19}]"> {{ "translations.TRAVEL_BACKPACKS" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:20}]"> {{ "translations.LABTOP_BAGS" | translate }}</a></li>
          </ul>
        </li>



        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ "translations.Gifts_Sets" | translate }}
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:13}]"> {{ "translations.Men" | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="['/products',  { CID:17}]"> {{ "translations.Women" | translate }}</a></li>
          </ul>
        </li>



      </ul>
    </div>
  </div>
</nav>
